"use client";
import * as React from "react";
const SvgMenuFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 12h16v-2H0zm0-5h16V5H0zm0-7v2h16V0z" }));
export {
  SvgMenuFilled as default
};
